import React from 'react';

import './button-spacer.css';

function ButtonSpacer() {
  return <div className='button-spacer' />;
}

ButtonSpacer.displayName = 'ButtonSpacer';

export default ButtonSpacer;



// WEBPACK FOOTER //
// ./src/components/util/ButtonSpacer.js